export default __webpack_public_path__ + "static/media/qa-icon.f9a07e7c.jpg";